const tinyHeader = (editor) => {
  if (!editor.dom) return;

  const container = editor.getContainer();

  const header = container.querySelector(".tox-editor-header");
  const menubar = header.querySelector(".tox-menubar");
  if (menubar) {
    // Avoid duplicate injection
    if (menubar.querySelector(".my-custom-menu")) return;

    // Inject Brand Logo "Vedas" on the left
    if (!menubar.querySelector(".custom-brand")) {
      const brandDiv = document.createElement("div");
      brandDiv.classList.add("custom-brand");
      brandDiv.style.display = "flex";
      brandDiv.style.alignItems = "baseline";
      brandDiv.style.gap = "2px";
      brandDiv.style.marginRight = "24px";
      brandDiv.style.marginLeft = "4px";
      brandDiv.innerHTML = `
        <img src="/vedas/images/logo.svg" alt="Vedas" style="height:23px; display:block; margin-bottom:2px;" />
      `;
      menubar.insertBefore(brandDiv, menubar.firstChild);
    }

    const newDiv = document.createElement("div");
    newDiv.classList.add("my-custom-menu");
    newDiv.innerHTML = `
      <div class="t-menu">
        <div data-custom-menu="downloadxml" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 11l5 4 5-4M5 21h14"/></svg>
          <span>Download XML</span>
        </div>
        <div data-custom-menu="xml" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21V9M7 13l5-4 5 4M5 3h14"/></svg>
          <span>Upload XML</span>
        </div>
        <div data-custom-menu="upload" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v5h5M14 3l5 5v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>
          <span>Upload File</span>
        </div>
        <div data-custom-menu="help" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.2 2.4c-.7.3-1.2.9-1.2 1.6v.4"/><circle cx="12" cy="17" r=".6" fill="#6B6B76"/></svg>
          <span>Help</span>
        </div>
      </div>
    `;
    menubar.appendChild(newDiv);

    const uploadBtn = newDiv.querySelector('[data-custom-menu="upload"]');
    const xmlBtn = newDiv.querySelector('[data-custom-menu="xml"]');
    const downloadXmlBtn = newDiv.querySelector('[data-custom-menu="downloadxml"]');
    const helpBtn = newDiv.querySelector('[data-custom-menu="help"]');

    if (uploadBtn) {
      uploadBtn.addEventListener("click", function () {
        editor.execCommand("uploadDoc");
      });
    }
    if (xmlBtn) {
      xmlBtn.addEventListener("click", function () {
        editor.execCommand("uploadXML");
      });
    }
    if (downloadXmlBtn) {
      downloadXmlBtn.addEventListener("click", function () {
        editor.execCommand("downloadXML");
      });
    }
    if (helpBtn) {
      helpBtn.addEventListener("click", function () {
        editor.execCommand("helping");
      });
    }
  }
};

export { tinyHeader };
